    

//     import { useEffect, useState } from "react";
// import "../css/Contact.css";
// import Footerlanding from "../landing/Footerlanding";
// import Navbarlanding from "../landing/Navbarlanding";
// import axios from "axios";
// import { parse } from "tldts";

// const Contact = () => {
//   const [company, setCompany] = useState({
//     name: "Your Bank",
//     logo: null,
//     email: "support@example.com",
//     phone: "+91 0000000000",
//     address: "123 Finance Street, New Delhi, India",
//     domain: "",
//     subdomain: "",
//   });

//   // Get domain/subdomain
//   const getDomainInfo = () => {
//     const hostname = window.location.hostname;
//     const parsed = parse(hostname);
//     return {
//       domain: parsed.domainWithoutSuffix || "",
//       subdomain: parsed.subdomain || "",
//     };
//   };

//   // Fetch company info dynamically
//   useEffect(() => {
//     const { domain } = getDomainInfo();
//     const fetchCompany = async () => {
//       try {
//         const response = await axios.get("https://narrowitsolution.in/api/get-company", {
//           params: { domain },
//         });
//         const data = response.data;
//         if (data && Object.keys(data).length > 0) {
//           setCompany((prev) => ({
//             ...prev,
//             name: data.name || prev.name,
//             logo: data.logo || prev.logo,
//             email: data.email || prev.email,
//             contact: data.contact || prev.contact,
//             address: data.address || prev.address,
//           }));
//         }
//       } catch (err) {
//         console.error("Company fetch failed:", err);
//       }
//     };
//     fetchCompany();
//   }, []);

//   return (
//     <div className="cont-shi-page">
//       {/* Navbar */}
//       <Navbarlanding />

//       {/* Hero Section */}
//       <section className="cont-shi-hero">
//         <h1>Contact Us</h1>
//         <p>
//           We’d love to hear from you! Fill out the form below or reach out using
//           our contact details.
//         </p>
//       </section>

//       {/* Contact Container */}
//       <div className="cont-shi-container">
//         {/* Contact Form */}
//         <div className="cont-shi-form">
//           <h2>Send Us a Message</h2>
//           <form>
//             <div className="cont-shi-form-group">
//               <label>Full Name</label>
//               <input type="text" placeholder="Enter your full name" required />
//             </div>

//             <div className="cont-shi-form-group">
//               <label>Email</label>
//               <input type="email" placeholder="Enter your email" required />
//             </div>

//             <div className="cont-shi-form-group">
//               <label>Phone</label>
//               <input type="tel" placeholder="Enter your phone number" />
//             </div>

//             <div className="cont-shi-form-group">
//               <label>Message</label>
//               <textarea
//                 placeholder="Write your message here..."
//                 required
//               ></textarea>
//             </div>

//             <button type="submit" className="cont-shi-btn-submit">
//               Send Message
//             </button>
//           </form>
//         </div>

//         {/* Contact Info */}
//         <div className="cont-shi-info">
//           <h2>Get in Touch</h2>
//           <p>
//             <strong>Address:</strong> {company.address}
//           </p>
//           <p>
//             <strong>Email:</strong> {company.email}
//           </p>
//           <p>
//             <strong>Phone:</strong> {company.contact}
//           </p>
//         </div>
//       </div>

//       {/* Footer */}
//       <Footerlanding />
//     </div>
//   );
// };

// export default Contact;


import { useEffect, useState } from "react";
import "../css/Contact.css";
import Footerlanding from "../landing/Footerlanding";
import Navbarlanding from "../landing/Navbarlanding";
import axios from "axios";
import { parse } from "tldts";

const Contact = () => {
  const [company, setCompany] = useState({
    name: "Your Bank",
    logo: null,
    email: "support@example.com",
    phone: "+91 0000000000",
    address: "123 Finance Street, New Delhi, India",
    domain: "",
    subdomain: "",
  });

  const getDomainInfo = () => {
    const hostname = window.location.hostname;
    const parsed = parse(hostname);
    return {
      domain: parsed.domainWithoutSuffix || "",
      subdomain: parsed.subdomain || "",
    };
  };

  useEffect(() => {
    const { domain } = getDomainInfo();
    const fetchCompany = async () => {
      try {
        const response = await axios.get(
          "https://narrowitsolution.in/api/get-company",
          { params: { domain } }
        );
        const data = response.data;
        if (data && Object.keys(data).length > 0) {
          setCompany((prev) => ({
            ...prev,
            name: data.name || prev.name,
            logo: data.logo || prev.logo,
            email: data.email || prev.email,
            contact: data.contact || prev.phone,
            address: data.address || prev.address,
          }));
        }
      } catch (err) {
        console.error("Company fetch failed:", err);
      }
    };
    fetchCompany();
  }, []);


  const getImageUrl = (path) => {
    if (!path) return "";
    const cleanPath = path.startsWith("images/") ? path.slice(7) : path;
    return `https://narrowitsolution.in/${cleanPath}`;
  };


  return (
    <div className="cont-shi-page">
      <Navbarlanding />

      {/* Hero Section */}
      <section className="cont-shi-hero">
        <h1>Contact Us</h1>
        <p>
          We'd love to hear from you! Fill out the form below or reach out
          directly using our contact details.
        </p>
      </section>

      {/* Contact Section */}
      <div className="cont-shi-container">
        {/* Contact Form */}
        <div className="cont-shi-form">
          <h2>Send Us a Message</h2>
          <form>
            <div className="cont-shi-form-group">
              <label>Full Name</label>
              <input type="text" placeholder="Enter your full name" required />
            </div>
            <div className="cont-shi-form-group">
              <label>Email</label>
              <input type="email" placeholder="Enter your email" required />
            </div>
            <div className="cont-shi-form-group">
              <label>Phone</label>
              <input type="tel" placeholder="Enter your phone number" />
            </div>
            <div className="cont-shi-form-group">
              <label>Message</label>
              <textarea placeholder="Write your message..." required />
            </div>
            <button type="submit" className="cont-shi-btn-submit">
              Send Message
            </button>
          </form>
        </div>

        {/* Contact Info */}
        <div className="cont-shi-info">
          <h2>Get in Touch</h2>
          {company.logo && (
            <img
            src={getImageUrl(company.logo)}
              alt={company.name}
              className="cont-shi-info-logo"
            />
          )}
          <p>
            <strong>Address:</strong> {company.address}
          </p>
          <p>
            <strong>Email:</strong> {company.email}
          </p>
          <p>
            <strong>Phone:</strong> {company.contact || company.phone}
          </p>
        </div>
      </div>

      <Footerlanding />
    </div>
  );
};

export default Contact;
